<script>
  export default {
    props: {
      data: {
        type: Object,
        required: true
      },
    },
  }
</script>
<template>
  <div :class="$style.listCaseItem">
    <div class="row">
      <!--左邊-->
      <div class="col-md-5 col-lg-4 listCaseItem__left">
        <template v-if="data.introimage">
          <div :style="`background-image: url(${data.introimage})`" class="listCaseItem__image"></div>
        </template>
        <template v-else>
          <div :style="`background-image: url(${require('@src/assets/images/case/item.jpg')})`"
               class="listCaseItem__image"></div>
        </template>
      </div>
      <!--右邊-->
      <div class="col-md-7 col-lg-8 listCaseItem__right">
        <div>
          <div class="listCaseItem__title"> {{ data.title }}</div>
          <div class="listCaseItem__description d-sm-block d-none" v-html="data.description"></div>
        </div>
        <div class="d-flex justify-content-between align-center mt-4">
          <div :class="$style.brandList" class="d-flex align-items-center">
            <div v-for="(item, $index) in data.brands" :key="$index" class="brandList__item">
              <router-link
                :to="{ name: 'brand-item', params: { brandAlias: item.alias } }"
                class="brandList__link"
              >
                <img
                  :alt="item.title"
                  class="brandList__logo"
                  :src="item.logo_image"
                />
              </router-link>
            </div>
          </div>
          <div class="listCaseItem__learnmore align-self-center">
            了解更多
            <i class="fal fa-chevron-right ml-2"></i>
          </div>
        </div>
      </div>
    </div>
    <router-link class="listCaseItem__link" :to="data.to"></router-link>
  </div>
</template>
<style lang="scss" module>
  .listCaseItem {
    position: relative;
    background: #FFF;
    border-radius: 2px;
    box-shadow: $box-shadow-base;
    transition: box-shadow 0.3s;

    &:hover {
      box-shadow: $box-shadow-base-hover;

      :global {
        .listCaseItem {
          &__title,
          &__learnmore {
            color: $color-primary;
          }
        }
      }
    }

    .brandList {
      :global {
        .brandList__item {
          &:not(:last-child) {
            margin-right: 5px;
          }
        }

        .brandList__logo {
          width: 151px;
          @include max-md {
            width: 120px;
          }

          @include max-sm {
            width: 90px;
          }
        }
      }
    }

    :global {
      .listCaseItem {
        &__link {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
        }

        &__image {
          padding-top: 90%;
          background: #EEE;
          background-position: center;
          background-size: cover;
          background-repeat: no-repeat;
          @include max-md {
            padding-top: 42%;
          }
        }
        &__content {
          padding: 1.875rem;
        }

        &__title {
          margin-bottom: 1.25rem;
          font-size: 1.875rem;
          font-weight: 500;
          line-height: 1.5;

          @include line-clamp(2, 3em);

          @include max-xl {
            font-size: 1.5rem;
          }

          @include max-lg {
            font-size: 1.125rem;
          }
        }

        &__description {
          line-height: 1.75;
          color: $color-gray-6;
          @include line-clamp(2, 3.5em);

          @include max-lg {
            @include line-clamp(2, 3.5em);

            font-size: 0.875rem;
          }

          @include max-md {
            margin-bottom: 1rem;
          }
        }

        &__left {
        }

        &__right {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 3.125rem;

          @include max-xl {
            padding: 1rem;
            padding-right: 2rem;
          }

          @include max-lg {
            padding: 1rem;
            padding-right: 2rem;
          }

          @include max-md {
            padding: 2rem;
          }
        }

        &__learnmore {
          font-weight: 500;

          @include max-xl {
            font-size: 1rem;
          }

          @include max-md {
            font-size: 0.85rem;
          }
        }
      }

    }
  }
</style>
